import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-user-unblocked',
  templateUrl: './user-unblocked.component.html',
  styleUrls: ['./user-unblocked.component.scss']
})
export class UserUnblockedComponent implements OnInit {
  Message: string;
  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<UserUnblockedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
    if (data) {
      let message = data.Message;
      this.Message = message.replace(/\. /g, '. <br>');
    }
   }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialog.closeAll();
  }
}
